import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestApi } from 'src/app/shared/RestApi/restApi';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CommonService } from 'src/app/shared/services/common.service';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';
import { MatDialog } from '@angular/material/dialog';
import { ImportZipComponent } from 'src/app/shared/common/ImportZipDialogData ';



export interface ImportExportFormData {
  rowData: any;
  dnsId: any;
}
interface commonServiceInfo {
  
  statusMessage: any;
  error: boolean;
  data: any[];

}
@Component({
    selector: 'app-import-export-centralized',
    templateUrl: './import-export-centralized.component.html',
    styleUrls: ['./import-export-centralized.component.scss'],
    standalone: false
})
export class ImportExportCentralizedComponent implements OnInit {

  importExportForm !: UntypedFormGroup;

  backgroundColorButton;
  allocateButtonsBoolean = false;
  allocateButtons1Boolean = true;
  selectedScreenOrModule: any; // 
  actionDownload = false; //
  actionupload = false; //

  moduleList: any[] = [];
  screenList: any[] = [];
  nameList: any[] = [];

  private headers = new HttpHeaders({
    "Content-Type": "application/json"
  });

  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private dialogref: MatDialogRef<ImportExportCentralizedComponent>,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private rest: RestApi,
    private http: HttpClient,
    private commonService: CommonService,
    private dialog: MatDialog,
    private localStorage: LocalStorageSettingsService,
     
    @Inject(MAT_DIALOG_DATA) public data: ImportExportFormData
  ) {
    // ✅ SAME COLOR LOGIC
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
  }

  ngOnInit(): void {

    // ✅ FORM SAME STYLE
    this.importExportForm = new UntypedFormGroup({
      type: new UntypedFormControl("", [Validators.required]),
      name: new UntypedFormControl("", [Validators.required]),
      action: new UntypedFormControl("", [Validators.required])
    });

    // ✅ Dummy data (replace with API)
    this.moduleList = ['HR', 'Finance', 'Sales'];
    this.screenList = ['Dashboard', 'Reports', 'Settings'];
  }

  // 🔁 Dynamic dropdown change
  async onTypeChange(event: any) {
    const value = event.value;

    const response = await firstValueFrom(
      this.http.get<commonServiceInfo>(
        this.rest.GET_TABLEORMODULE_FOR_IMPORTEXPORT + "/" + value,
        { headers: this.headers }
      )
    );

    this.spinner.stop();

    if (!response) return;

    if (response.error) {
      this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
      return;
    }

    // ✅ same structure for both screen & module
    this.nameList = response.data || [];

    // optional: store separately if needed
    if (value === 'module') {
      this.moduleList = this.nameList;
    } else {
      this.screenList = this.nameList;
    }
  }


  onNameChange(event: any) {
    const selected = event.value;
    this.selectedScreenOrModule = selected;
    console.log("Selected full object:", selected);
    console.log("selectedScreenOrModule - " + this.selectedScreenOrModule)

    if (selected.table_name === null) {
      // ✅ Module
      console.log("Module:", selected.importtype);
      this.actionDownload = true;
    } else {
      // ✅ Screen
      console.log("Screen:", selected.screenId);
      console.log("Table:", selected.table_name);
      console.log("Import Type:", selected.importtype);
      this.actionDownload = true;
    }
  }
  onDownloadUpload(event: any) {

    console.log(event)
    console.log(event.value)
    console.log(this.selectedScreenOrModule.table_name)
    if (event.value == "download") {
      this.actionDownload = true
    } else if (event.value == "upload") {
      this.actionupload = true;
    }
    
    
  }

 

  async exportData(tablename: string) {


    this.snackBar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
    const tenantid = localStorage.getItem("dnsName");
    

    try {
      const blob = await this.commonService.downloadJsonFile(tablename, tenantid);
      const link = document.createElement('a');
      const timestamp = new Date().getTime();
      link.href = window.URL.createObjectURL(blob);
      link.download = `${tablename}_export_${timestamp}.json`;
      link.click();
      window.URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Error downloading JSON:', error);
    }


  }
  async zipExport() {
    //console.log(e)
    //const snapshotId = e.rowData.mappingevrsionid;
    const importType = this.selectedScreenOrModule.importtype;
    const tenantId = localStorage.getItem("dnsName");

    console.log(tenantId)

    this.snackBar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });



    try {
      const blob = await this.commonService.downloadzipFile("0", tenantId, importType);
      const link = document.createElement('a');
      const timestamp = new Date().getTime();
      link.href = window.URL.createObjectURL(blob);
      link.download = `${importType}_export_${timestamp}.zip`;
      link.click();
      window.URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Error downloading JSON:', error);
    }


  }

  
  importzipData() {
     
    console.log("<--- Inside upload Group Template --->")
    let width = "85%";
    let dialogRef = this.dialog.open(ImportZipComponent, {
      maxWidth: "70vw",
      height: "50%",
      width: width,
      data: { "tablename": this.selectedScreenOrModule.importtype },
      disableClose: true,
    });
      
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      
      //this.reportCreationData = result;
      
      //this.vaultObjectService.retrieveobjectgroup();
    });
      
      
  }
  

  
  

importData(tablenameimp: string) {
         
  let tenantid = localStorage.getItem("dnsName")
  console.log("<--- Inside upload Group Template --->")
  let width = "85%";
  let dialogRef = this.dialog.open(ImportJsonComponent, {
    maxWidth: "70vw",
    height: "50%",
    width: width,
    data: { "tablename": tablenameimp, "tenantid": tenantid },
    disableClose: true,
  });
          
  dialogRef.afterClosed().subscribe((result) => {
    console.log(result);
    console.log("tenantid");
    //this.reportCreationData = result;
          
    //this.vaultObjectService.retrieveobjectgroup();
  });
} 
          
        
  // Close popup
  closeFunction() {
    this.dialogref.close(false);
  }
  onDownload() {
    console.log(this.selectedScreenOrModule)
    const tableforExp = this.selectedScreenOrModule.table_name;
    const scName = this.selectedScreenOrModule.screenId;
    console.log(tableforExp);
    if (tableforExp != undefined || tableforExp != null) {
      console.log("inside onDownload")
      if (scName == "Object Group") {
        this.exportData("objectgroup");
        this.exportData("mstrobjectgroup");
        
      } else {
        this.exportData(tableforExp);
      }
       
    } else {
      this.zipExport();
    }
  }
  onUpload() {
    console.log(this.selectedScreenOrModule)
    const tableforimp = this.selectedScreenOrModule.table_name;
    const scName = this.selectedScreenOrModule.screenId;
    console.log(tableforimp);
    if (tableforimp != undefined || tableforimp != null) {
      console.log("inside onDownload")
      if (scName == "Object Group") {
        this.importData("mstrobjectgroup");
      } else {
        this.importData(tableforimp);
      }

    } else {
      this.importzipData();
    }
  }

  // Submit logic
  submit() {

    if (!this.importExportForm.valid) {
      this.importExportForm.markAllAsTouched();
      return;
    }

    const formData = this.importExportForm.value;
    console.log(formData);

    this.spinner.start();

    // 🔥 Example logic (replace with API)
    setTimeout(() => {

      this.spinner.stop();

      if (formData.action === 'upload') {
        this.snackBar.open("Upload started successfully", "OK", { duration: 3000 });
      } else {
        this.snackBar.open("Download started successfully", "OK", { duration: 3000 });
      }

      this.dialogref.close(true);

    }, 1000);
  }
}
